
import React from "react";
import MyNavbar from "../../../components/student/mynavbar/MyNavbar"; 
import Cards from "../../../screens/student/home/Cards"; 
import ConservationSection from "./ConservationSection";
import HomeSubScreen from "../home/HomeSubScreen";
import FaqSection from "../../../subscreens/student/FaqSection";
import Footer from "../../../components/student/footer/Footer";
import Testimonies from "../../../subscreens/student/Testimonies"
import Volunteer from "../../../subscreens/student/Volunteer";
import HeroSection from "../../../screens/student/home/HeroSection";
import LatestBlogs from "../../../subscreens/student/LatestBlogs";
import NGOSection from "../../../screens/student/home/NGOSection";
import '../../../assets/css/student/home/Home.css';

const Home = () => {
    return(  
         <>

        <MyNavbar />
        <HeroSection />
        <Cards />
        <HomeSubScreen/>
        <LatestBlogs />
        <ConservationSection/>
        <Testimonies/>
        <Volunteer/>
         <NGOSection/>
        <FaqSection />
        <Footer/>
      </>



  );
};

export default Home;







